import { VIEWBY_ENUMS } from '../../constants/constant';
import actionTypes from '../actionTypes';
import { transCustAttrResp } from '../utils';

export const initialState = {
	viewByFilter: VIEWBY_ENUMS.DEPARTMENT,
	breakDownByFilter: '',
	timePeriodFilter: [],
	newTimePeriodFilter: [],
	readyToDownload: true,
	enableDownload: false,
	viewByType: 'WMT_ATTR',
	breakDownByType: '',
	custAttrNames: [],
};

const tableReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.SET_VIEWBY_FILTER: {
			return {
				...state,
				viewByFilter: action.payload,
			};
		}
		case actionTypes.SET_BREAKDOWNBY_FILTER: {
			return {
				...state,
				breakDownByFilter: action.payload,
			};
		}
		case actionTypes.SET_TIME_PERIOD_FILTER: {
			return {
				...state,
				timePeriodFilter: action.payload,
			};
		}
		case actionTypes.SET_NEW_TIME_PERIOD_FILTER: {
			return {
				...state,
				newTimePeriodFilter: action.payload,
			};
		}
		case actionTypes.SET_EXCEL_DOWNLOAD: {
			return {
				...state,
				readyToDownload: action.payload,
			};
		}
		case actionTypes.SET_ENABLE_DOWNLOAD: {
			return {
				...state,
				enableDownload: true,
			};
		}
		case actionTypes.SET_VIEW_BY_TYPE: {
			return {
				...state,
				viewByType: action?.payload,
			};
		}
		case actionTypes.SET_BREAK_DOWN_BY_TYPE: {
			return {
				...state,
				breakDownByType: action?.payload,
			};
		}
		case actionTypes.SET_CUSTOM_ATTRIBUTE_NAMES: {
			return {
				...state,
				custAttrNames: transCustAttrResp(action?.payload),
			};
		}
		case actionTypes.RESET_FILTERS: {
			return {
				...state,
				viewByType: 'WMT_ATTR',
				breakDownByType: '',
			};
		}
		default:
			return state;
	}
};

export default tableReducer;
